module.exports = __webpack_public_path__ + "img/76_4.0515e15f.png";